import { isShuttleVehicle } from "features/CenterContent/VehicleDetails/AlternativeTransportDetails/utils";
import { VehicleSummary } from "features/CenterContent/VehicleDetails/shared/VehicleSummary";
import { vehicleTypeToIcon } from "features/CenterContent/VehicleDetails/shared/utils";
import { removeStationFromStopName } from "features/VehicleSidebar/VehicleList/utils/stopNameUtils";
import { FC } from "react";
import { HStack, Text, tokens, VStack } from "shared/components/Spor";
import { AlternativeTransportVehicle } from "shared/types/alternativeTransport";
import styled, { useTheme } from "styled-components";

type Props = {
  alternativeTransport: AlternativeTransportVehicle;
};

const OperatorText = styled.div`
  position: absolute;
  right: 0;
  bottom: 0;

  @container altTransportPage (width >= 1696px) {
    position: static;
    margin-top: auto;
  }
`;

export const Itinerary: FC<Props> = ({ alternativeTransport }) => {
  const {
    lineNames,
    tripPatternId,
    trainIds,
    itinerary,
    type,
    vehicleStatus,
    driverPhoneNumber,
    hastusShuttlePlanId,
    originStopName,
    destinationStopName,
    firstStopName,
    scheduledDepartureTimeOrigin,
    scheduledArrivalTimeDestination,
    logs,
    operatorName,
  } = alternativeTransport;

  // Prefix unused variables with an underscore so the linter accepts them as intentionally unused
  const [_Icon, _iconTitle] = vehicleTypeToIcon.get(type)!;

  const isShuttle = isShuttleVehicle(alternativeTransport);
  const returnStops = itinerary?.returnStops ?? [];
  const theme = useTheme();

  const turnaroundStopName =
    returnStops.length > 0 ? returnStops[returnStops.length - 1].name : null;

  const replacesTrainIds = trainIds.length > 0 ? trainIds.join(", ") : null;

  const tripDetails = [lineNames, hastusShuttlePlanId || tripPatternId]
    .filter((stop): stop is string => stop !== null && stop !== "")
    .join(" / ");

  const stations = [
    removeStationFromStopName(originStopName),
    removeStationFromStopName(destinationStopName),
    turnaroundStopName,
  ]
    .filter((stop): stop is string => stop !== null && stop !== "")
    .join("–");

  return (
    <HStack
      alignItems="stretch"
      mt={`-${tokens.default.size.spacing[1.5]}`}
      w="100%"
      position="relative"
    >
      <VehicleSummary
        title={replacesTrainIds ?? _iconTitle}
        type={type}
        subTitle={tripDetails}
        route={stations.concat(
          isShuttle && firstStopName && firstStopName !== originStopName
            ? ` (oppstart ${firstStopName})`
            : "",
        )}
        startTime={scheduledDepartureTimeOrigin}
        endTime={scheduledArrivalTimeDestination}
        vehicleStatus={vehicleStatus}
        logs={logs}
        driverPhoneNumber={driverPhoneNumber}
      />
      <VStack align="end" minW="0" gap={1}>
        <OperatorText>
          <Text
            fontStyle="italic"
            variant="sm"
            whiteSpace="nowrap"
            color={theme.colorTextSecondary}
          >
            Kjøres av: {operatorName}
          </Text>
        </OperatorText>
      </VStack>
    </HStack>
  );
};
